import { useTranslate } from "@similarweb/i18n-provider";
import { Tabs, TabList, TabPanel, Tab } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { SwitcherOption } from "../shared/ShareTypeSwitcher";
import { SWITCHER_OPTIONS } from "../shared/ShareTypeSwitcher";

interface IDisplayAdvertisersPublishersTabsProps {
    isCompareMode: boolean;
    selectedSwitcherOption: SwitcherOption;
    setSelectedSwitcherOption: (switcherOption: SwitcherOption) => void;
}

export const DisplayAdvertisersPublishersTabs = ({
    isCompareMode,
    selectedSwitcherOption,
    setSelectedSwitcherOption,
}: IDisplayAdvertisersPublishersTabsProps) => {
    const { translate } = useTranslate();
    if (!isCompareMode) {
        return null;
    }

    return (
        <Flex
            flexDirection="column"
            gap="24px"
        >
            <Tabs
                selectedIndex={selectedSwitcherOption}
                onSelect={setSelectedSwitcherOption}
            >
                <TabList>
                    {Object.values(SWITCHER_OPTIONS).map((option) => (
                        <Tab key={option}>{translate(option)}</Tab>
                    ))}
                </TabList>
                {Object.values(SWITCHER_OPTIONS).map((option) => (
                    <TabPanel key={option}></TabPanel>
                ))}
            </Tabs>
        </Flex>
    );
};
